module.exports = __webpack_public_path__ + "static/media/path-11-copy.5495a8b2.svg";